import { ResponsiveBar } from '@nivo/bar'
import type React from 'react'
import type { OrdersByTradeTypeDto } from '../../../../../../types/coreApi-types'
import { formatNumber } from '../../../../../../utils/formatters'

interface OrdersByTradeTypeChartProps {
  data: OrdersByTradeTypeDto[]
}

const OrdersByTradeTypeChart: React.FC<OrdersByTradeTypeChartProps> = ({
  data,
}) => {
  const chartData = data.map(item => ({
    tradeType: item.tradeTypeName,
    orders: item.orderCount,
    volume: item.totalVolume,
    percentage: item.percentageOfTotal,
  }))

  return (
    <div className="h-[400px]">
      <ResponsiveBar
        data={chartData}
        keys={['orders']}
        indexBy="tradeType"
        margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
        padding={0.3}
        valueScale={{ type: 'linear' }}
        indexScale={{ type: 'band', round: true }}
        colors={{ scheme: 'nivo' }}
        borderColor={{
          from: 'color',
          modifiers: [['darker', 1.6]],
        }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: 'Trade Type',
          legendPosition: 'middle',
          legendOffset: 32,
        }}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: 'Order Count',
          legendPosition: 'middle',
          legendOffset: -40,
        }}
        labelSkipWidth={12}
        labelSkipHeight={12}
        labelTextColor={{
          from: 'color',
          modifiers: [['darker', 1.6]],
        }}
        tooltip={({ data: tooltipData }) => {
          const item = data.find(d => d.tradeTypeName === tooltipData.tradeType)
          return (
            <div className="bg-white p-3 shadow-lg rounded-lg border border-gray-200">
              <div className="font-semibold">{tooltipData.tradeType}</div>
              <div className="text-sm text-gray-600">
                Orders: {tooltipData.orders}
              </div>
              {item && (
                <>
                  <div className="text-sm text-gray-600">
                    Volume:{' '}
                    {formatNumber(item.totalVolume, {
                      currencyType: 'FiatCurrency',
                      isoCode: 'EUR',
                    })}
                  </div>
                  <div className="text-sm font-medium text-gray-800">
                    {item.percentageOfTotal.toFixed(2)}% of total
                  </div>
                </>
              )}
            </div>
          )
        }}
        animate={true}
        motionConfig="gentle"
      />
    </div>
  )
}

export default OrdersByTradeTypeChart
